<script setup lang="ts">
import { default as PrimeButton } from 'primevue/button'
import Chip from 'primevue/chip'
import MultiSelect, { type MultiSelectPassThroughOptions } from 'primevue/multiselect'
import { type ComponentPublicInstance, computed, ref, useAttrs } from 'vue'
import LoadingSpinner from '../icons/LoadingSpinner.vue'
import { SelectFilter, type SelectProps, useSelect } from '../primevue/select'

const props = withDefaults(defineProps<SelectProps>(), { showFilter: true })
const model = defineModel<string[]>({ default: [] })
const rootElement = ref<ComponentPublicInstance | null>(null)
const { attrs, loading, loadOptions, labelOf } = useSelect(model, props, rootElement)
const ownAttrs = useAttrs()
const chipPassThrough = computed(() => (ownAttrs.pt as MultiSelectPassThroughOptions | undefined)?.pcChip)
</script>

<template>
  <MultiSelect ref="rootElement" v-bind="attrs" display="chip" :show-toggle-all="false" scroll-height="">
    <template v-for="(_, name) in $slots" #[name]="slotProps">
      <slot :name="name" v-bind="slotProps" />
    </template>
    <template v-if="!$slots.chip" #chip="{ value, removeCallback }">
      <Chip
        class="p-multiselect-chip"
        :label="labelOf(value)"
        :pt="chipPassThrough"
        removable
        @remove="removeCallback($event, value)"
      />
    </template>
    <template #header>
      <SelectFilter v-if="props.showFilter" @update:modelValue="loadOptions" />
    </template>
    <template v-if="loading" #empty>
      <div class="flex items-center justify-center overflow-hidden">
        <LoadingSpinner class="h-16 w-16" />
      </div>
    </template>
    <template #footer>
      <div class="px-4 py-2 flex justify-end">
        <PrimeButton label="Clear" severity="secondary" size="small" icon="pi pi-times" @click="model = []" />
      </div>
    </template>
  </MultiSelect>
</template>
